module.exports = __webpack_public_path__ + "static/media/pagina-web.72f1dc17.jpg";